import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';

import {
  EditTicketNumberSequenceMutation as EditTicketNumberSequence,
  EditTicketNumberSequenceInput,
} from '__generated__/graphql';

import { useNotifier } from '../../../common/Notifications/NotificationProvider';
import EditTicketNumberSequenceMutation from './EditTicketNumberSequenceMutation';
import useScroll from '../../../common/useScroll';

interface UseEditTicketNumberSequenceMutationProps {
  input: EditTicketNumberSequenceInput,
  onSuccess?: (ticket: EditTicketNumberSequence['editTicketNumberSequence']) => void;
}

const useEditTicketNumberSequenceMutation = ({
  input, onSuccess,
}: UseEditTicketNumberSequenceMutationProps) => {
  const { t } = useTranslation();
  const notifier = useNotifier();
  const { scrollToIfInvisible } = useScroll();

  return useMutation(
    EditTicketNumberSequenceMutation,
    {
      variables: {
        input,
      },
      onCompleted: ({ editTicketNumberSequence: sequence }) => {
        notifier.success(t('notifications.ticket_number_sequence_saved'));

        onSuccess?.(sequence);
      },
      onError: () => {
        scrollToIfInvisible(`TicketNumberSequenceCard_${input.id}`);
      },
    },
  );
};

export default useEditTicketNumberSequenceMutation;
